import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    headerRow: {
      marginTop: theme.spacing(1),
    },
    tableCellHeader: {
      padding: theme.spacing(1),
      borderBottom: '1px solid #ddd',
      fontSize: 'small',
      verticalAlign: 'middle',
      fontWeight: 'bold',
    },
    responsibleHeader: {
      width: '160px',
      textAlign: 'left',
    },
    dueHeader: {
      width: '130px',
      textAlign: 'left',
      whiteSpace: 'nowrap',
    },
    tableCellRoot: {
      padding: theme.spacing(0.5),
      borderBottom: '1px solid #ddd',
      fontSize: 'small',
      verticalAlign: 'middle',
      letterSpacing: 0,
    },
    firstCell: {
      width: '50px',
      paddingLeft: theme.spacing(1),
    },
    smallCell: {
      width: '50px',
    },
    textCell: {
      width: '350px',
    },
    textClamped: {
      display: '-webkit-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'normal',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      lineHeight: '1.4em',
      maxHeight: '2.8em',
      width: '95%',
    },
    statusCell: {
      width: '170px',
    },
    responsibleCell: {
      width: '130px',
    },
    itemCell: {
      padding: theme.spacing(1),
    },
    dueCell: {
      width: '120px',
    },
    tableRow: {
      display: 'table-row',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
      lineHeight: '1',
      height: '20px',
    },
    selectedTableRow: {
      backgroundColor: '#e7f9ff',
      '&:hover': {
        backgroundColor: '#d6f2ff',
      },
    },
    avatar: {
      marginLeft: '5px',
      width: '20px',
      height: '20px',
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    itemValues: {
      display: 'flex',
      gap: theme.spacing(1),
      flexDirection: 'column',
    },
    itemLabel: {
      fontWeight: 700,
    },
    semiItem: {
      display: 'flex',
      gap: theme.spacing(1),
    },
  };
};
